import type { ReactElement } from "react";
import { FiHeart, FiLinkedin, FiTwitter } from "react-icons/fi";

export function Footer(): ReactElement {
	return (
		<footer className="border-line bg-surface-raised border-t py-8">
			<div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-4 px-6 md:flex-row lg:px-12">
				<p className="text-fg-ghost text-[10px] tracking-[0.2em] uppercase">
					&copy; 2026 Baseline Reset LLC
				</p>

				<div className="text-fg-ghost flex items-center gap-6">
					<p className="flex items-center gap-1.5 text-[10px] tracking-[0.2em] uppercase">
						Made with{" "}
						<FiHeart className="inline h-3 w-3 fill-red-500 text-red-500" />{" "}
						in NYC
					</p>

					<div className="flex gap-6">
						<a
							className="hover:text-accent transition-colors"
							href="#"
							aria-label="Twitter"
						>
							<FiTwitter className="h-4 w-4" />
						</a>
						<a
							className="hover:text-accent transition-colors"
							href="#"
							aria-label="LinkedIn"
						>
							<FiLinkedin className="h-4 w-4" />
						</a>
					</div>
				</div>
			</div>
		</footer>
	);
}
